import { DESKTOP_LOGIN } from '@launcher/constants';

export const isLoginWebview = (): boolean => {
  const params = new URL(window.location.href).searchParams;
  const isLoginWebViewFromSessionStorage = !!window.sessionStorage.getItem('IS_LOGIN_WEBVIEW');
  const isLoginWebivewFromSearchParams = Boolean(params.get(DESKTOP_LOGIN));

  // We use session storage to keep trace of webview after auth provider redirection (we lost search params in this case)
  if (isLoginWebivewFromSearchParams && !isLoginWebViewFromSessionStorage) {
    window.sessionStorage.setItem('IS_LOGIN_WEBVIEW', '1');
  }

  return isLoginWebivewFromSearchParams || isLoginWebViewFromSessionStorage;
};
